module.exports = __webpack_public_path__ + "static/img/xiaochengxu-erweima.cc43694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaochengxu-erweima.jpg
// module id = 9fRn
// module chunks = 2